<template>
  <div>
    <b-form-group
        :label="$t('message.Name_uz')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="category.name_uz"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_ru')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="category.name_ru"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_en')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="category.name_en"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_kr')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="category.name_kz"
          required
      />
    </b-form-group>
    <div
        style="margin-top: 30px; margin-left: 150px">
      <b-button
          variant="outline-primary"
          @click="handleClick"
      >{{$t('message.Cancel')}}
      </b-button>
      <b-button
          @click="handleSubmit"
          style="margin-left: 10px"
          variant="primary"
      >{{$t('message.Add')}}
      </b-button>
    </div>
  </div>
</template>

<script>

import {addCategory, editCategory, getCategoryById} from "../../../../../../api/categories";

export default {
  name: "CategoryModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      category: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchCategory(){
      getCategoryById({ id: this.id}).then(response => {
        this.category = response.data.data
      })
    },
    handleSubmit() {
      if (this.category.name_uz
          && this.category.name_ru
          && this.category.name_en
          && this.category.name_kz) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editCategory(this.category).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addCategory(this.category).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchCategory()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>




